/* eslint-disable max-len */
import React from 'react';
import { compose } from 'redux';
import withLayout from '../../../core/components/with-layout';

import {
  Container,
  Segment,
  Text,
  Instructions,
} from './styles';

const Blocked = () => (
  <Container>
    <Segment>
      <Instructions>
        <Text>
          You have been removed from the PlaybookUX participant panel.
          {'\n'}
          {'\n'}
          The email on file was notified.
          {'\n'}
          {'\n'}
          You will not be able to test with PlaybookUX in the future. All removal decisions are final and will not be overturned.
        </Text>
      </Instructions>
    </Segment>
  </Container>
);

export default compose(withLayout({ blocked: true }))(Blocked);
